import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';
import { cn } from '../../utils/cn/cn';

const variants = cva('rounded-lg bg-white p-3', {
  variants: {
    variant: {
      none: '',
      elevated: 'shadow-xl',
      border: 'border border-neutral-400',
      'elevated-border': 'border border-neutral-400 shadow-xl',
      'elevated-border-loud': 'border-2 border-black shadow-xl',
      tinted: 'bg-brand-grey_7',
      'tinted-border': 'border border-neutral-400 bg-brand-grey_7',
      'elevated-tinted': 'border border-neutral-400 bg-brand-grey_7 shadow-xl',
      accented: 'border border-neutral-400 bg-purple-50',
    },
    error: {
      true: 'border-2 border-dashed border-brand-cliffordRed',
      false: '',
    },
  },
  defaultVariants: {
    variant: 'none',
    error: false,
  },
});

export interface CardProps
  extends ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof variants> {}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ variant, error, className, ...props }, ref) => (
    <div
      {...props}
      className={cn(variants({ variant, error }), className)}
      ref={ref}
    />
  )
);

Card.displayName = 'Card';
